import HospitalAdd from './HospitalAdd';

export default HospitalAdd;
